import { GraphViewType } from '../types';
import { coolGrey } from '@jupiterone/jupiter-web-toolkit/src/theme/palette/coolGrey';
import { blue } from '@jupiterone/jupiter-web-toolkit/src/theme/palette/blue';

const UA = navigator.userAgent.toLowerCase();
const FONT_FACE = 'Lato, sans-serif';
const NO_SHADOW = UA.indexOf('safari') !== -1 && UA.indexOf('chrome') === -1;
export const MAX_ANIMATION_DURATION = 4_000;

export const RIGID_GRAPH_PHYSICS = {
  barnesHut: {
    gravitationalConstant: -1_000,
    centralGravity: 0.3,
    springLength: 100,
    springConstant: 0.03,
    damping: 0.15,
    avoidOverlap: 0.25,
  },
  maxVelocity: 100,
  minVelocity: 0.75,
  timestep: 0.9,
  stabilization: {
    enabled: true,
    iterations: 100, // Max value used by LinearProgess bar progress.
    updateInterval: 10,
    fit: true, // Auto-resize the zoom scale.
  },
};

export const CURVED_GRAPH_EDGES = {
  arrowStrikethrough: false,
  width: 1,
  arrows: {
    to: {
      enabled: true,
    },
  },
  smooth: {
    type: 'horizontal',
    forceDirection: 'none',
  },
  color: {
    // @ts-ignore
    color: coolGrey[200],
    // @ts-ignore
    highlight: blue[500],
    hover: coolGrey[300],
  },
  font: {
    color: blue[900],
    face: FONT_FACE,
    size: 12,
    strokeColor: 'white',
    strokeWidth: 5,
  },
};

export const commonLayoutConfig = {
  improvedLayout: false,
  randomSeed: 1,
};

export const MESH_LAYOUT = {
  ...commonLayoutConfig,
  hierarchical: false,
};

export const getTreeLayout = (graphType: GraphViewType) => ({
  ...commonLayoutConfig,
  hierarchical: {
    direction: graphType === GraphViewType.tree ? 'LR' : 'UD',
    parentCentralization: false,
    levelSeparation: 150,
    blockShifting: false,
    edgeMinimization: false,
    sortMethod: 'directed',
    shakeTowards: 'roots',
  },
});

export const LIMITED_GRAPH_INTERACTION = {
  hover: true,
  keyboard: {
    enabled: false,
  },
  multiselect: true,
  hideEdgesOnZoom: true,
};

export const ORB_GRAPH_NODES = {
  shape: 'diamond',
  size: 25,
  chosen: {
    label: (values: any, id: string, selected: boolean, hovering: boolean) => {
      if (selected) {
        values.color = 'black';
        values.strokeWidth = 5;
        values.size = 16;
      }
    },
  },
  font: {
    face: FONT_FACE,
    color: 'black',
    strokeWidth: 0,
    strokeColor: 'white',
    size: 12,
  },
  shadow: {
    enabled: !NO_SHADOW,
    color: coolGrey[300],
    size: 12,
    x: 0,
    y: 0,
  },
};
